import { DatasetAccessStatus } from '~/api/types';

export enum DatasetAccessTables {
  ALL = 'all datasets',
  MY_DATASETS = 'my datasets',
  APPROVED = 'approved datasets',
}

export const datasetAccessConfig = {
  [DatasetAccessTables.ALL]: null,
  [DatasetAccessTables.APPROVED]: DatasetAccessStatus.APPROVED,
  [DatasetAccessTables.MY_DATASETS]: null,
};
